import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Hanken_Grotesk\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-hanken-grotesk\",\"display\":\"swap\"}],\"variableName\":\"hankenGrotesk\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/PostHogPageView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PHProvider"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProviderContextProvider"] */ "/app/src/components/chat_search/ProviderContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AssistantsProvider"] */ "/app/src/components/context/AssistantsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoType"] */ "/app/src/components/logo/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/app/src/components/settings/SettingsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/app/src/components/user/UserProvider.tsx");
